/**
 * 官网 SEO：站点根 URL 与可收录的公开路径（单一路径清单，供 sitemap / robots / metadataBase 使用）
 */

export const DEFAULT_MARKETING_ORIGIN = 'https://www.fundamuse.com';

/** 与 NEXT_PUBLIC_BRAND_SITE_URL 对齐；用于 sitemap、robots 中的 Sitemap 绝对地址、metadataBase */
export function getMarketingSiteOrigin(): string {
  const raw = process.env.NEXT_PUBLIC_BRAND_SITE_URL?.trim();
  if (raw) {
    try {
      return new URL(raw).origin;
    } catch {
      // ignore invalid env
    }
  }
  return DEFAULT_MARKETING_ORIGIN;
}

/**
 * 仅官网对外公开、希望被索引的路径（不含需登录的创作者端；不含与首页重复的 /home）
 * 注：/copyright 等为创作者端 Dashboard，不纳入官网收录列表
 */
export const MARKETING_INDEXABLE_PATHS: readonly string[] = [
  '/',
  '/about',
  '/team',
  '/careers',
  '/contact',
  '/investors',
];
